<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { InfoLevel } from "@/model/baseTypes";
import type { Icon } from "@/model/icon";

defineProps<{ type: InfoLevel }>();

const icon: Record<InfoLevel, Icon> = {
  default: "iteration/default",
  ok: "iteration/ok",
  warn: "iteration/warn",
  error: "iteration/error",
};

const label: Record<InfoLevel, string> = {
  default: /*$t*/ "label.iterationFlag.default",
  ok: /*$t*/ "label.iterationFlag.ok",
  warn: /*$t*/ "label.iterationFlag.warn",
  error: /*$t*/ "label.iterationFlag.error",
};
</script>

<template>
  <SvgIcon
    :name="icon[type]"
    :class="['iteration-flag', type]"
    :aria-label="$t(label[type])"
    role="img"
  />
</template>
